import { useState, useEffect } from "react";
import ReportRevenueBoard from "./ReportRevenueBoard";
import { Input, DatePicker, Pagination, Select, message, ConfigProvider } from "antd";
import { CUSTOEMR_REPORT_STATUS, PAGINATION_PAGE_OPTIONS } from "../../../constant/constants";
import ReportTable from "./ReportTable";
import dayjs from "dayjs";
import { isDate1GreaterThanDate2 } from "../../../utils/Common";
import useUserStore from "../../../stores/store";

export default function CustomerReportComponent({
  summaryData,
  reportData,
  setCustomerFilter,
  handleFilterApply,
  page,
  perPage,
  setPerPage,
  total,
  handlePageChange,
  setIsFilterClear,
  handleDownload,
  loading,
}) {
  const { showNotification } = useUserStore();
  const [mobileNo, setMobileNo] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    setCustomerFilter((prev) => ({
      ...prev,
      mobileNo: mobileNo.trim(),
      fromDate,
      toDate,
      status,
      page,
      perPage,
    }));
  }, [mobileNo, fromDate, toDate, status, page, perPage]);

  function onHandleMobile(e) {
    const val = e.target.value;
    setMobileNo(val);
  }

  function onHandleFromDate(date, dateString) {
    if (isDate1GreaterThanDate2(dateString, toDate)) {
      showNotification("From Date cannot be greater than To Date.");
      return;
    }

    setFromDate(dateString);
  }

  function onHandleToDate(date, dateString) {
    if (date) {
      if (fromDate != "" && !(new Date(dateString) >= new Date(fromDate))) {
        message.warning("This date must be grater than from date.");
        return;
      }
      setToDate(dateString);
    } else {
      setToDate("");
    }

  }

  function onHandleStatus(value) {
    setStatus(value);
  }

  function onHandleClearFilter() {
    setIsFilterClear(true);
    setMobileNo("");
    setFromDate("");
    setToDate("");
    setStatus("");

    setCustomerFilter((prev) => ({
      restaurantId: prev.restaurantId,
      page: 1,
      perPage: 10,
    }));
  }

  return (
    <section className="min-h-[70vh]">
      {/* revenue board */}
      <ReportRevenueBoard summaryData={summaryData} data={reportData} handleDownload={handleDownload} />

      {/* filters */}
      <ConfigProvider
        theme={{
          components: {
            DatePicker: {
              zIndexPopup: 1,
            },
            Select: {
              zIndexPopup: 1,
            },
          },
        }}
      >
        <div className="flex items-center space-between w-full mt-[20px] mb-[31px]">
          <div className="flex items-center space-x-[15px] items-center w-full">
            <div className="h-[48px] w-[25%]">
              <Input className="h-full w-full" value={mobileNo || ""} onChange={onHandleMobile} placeholder="Mobile" />
            </div>
            <div className="h-[48px] w-[20%]">
              <DatePicker
                className={"h-full w-full"}
                value={fromDate ? dayjs(fromDate) : null}
                onChange={onHandleFromDate}
                placeholder="From Date"
                disabledDate={(current) => current && current > dayjs().endOf("day")}
              />
            </div>
            <div className="h-[48px] w-[20%]">
              <DatePicker
                className={"h-full w-full"}
                value={toDate ? dayjs(toDate) : null}
                onChange={onHandleToDate}
                placeholder="To Date"
                disabledDate={(current) => {
                  if (!fromDate) {
                    return current && current > dayjs().endOf("day");
                  }
                  return (current && current < dayjs(fromDate).startOf("day")) || current > dayjs().endOf("day");
                }}
              />
            </div>
            <div className="h-[48px] w-[23%]">
              <Select
                className="w-full h-full"
                showSearch={false}
                placeholder="Status"
                optionFilterProp="label"
                options={CUSTOEMR_REPORT_STATUS}
                value={status || null}
                onChange={onHandleStatus}
              />
            </div>
          </div>
          <div className="h-[48px] w-[200px]">
            <div className="flex items-center space-x-[20px] h-[48px] w-[200px]">
              <button
                className="w-full h-full bg-black text-[14px] font-bold leading-[16px] text-white rounded-[5px] w-[50%]"
                onClick={onHandleClearFilter}
              >
                Clear
              </button>
              <button
                className="w-full h-full bg-[#FCBD10] text-[14px] font-bold leading-[16px] text-black rounded-[5px] w-[50%]"
                onClick={handleFilterApply}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </ConfigProvider>
      {/* sales report table */}
      <div>
        <ReportTable data={reportData} context={"customers"} page={page} perPage={perPage} isLoading={loading} />
        <div className="mt-[20px] mb-[50px] report-pagination relative custom-pagination-options">
          <Pagination
            showSizeChanger
            onChange={handlePageChange}
            onShowSizeChange={(current, size) => {
              setPerPage(size);
            }}
            current={page}
            pageSize={perPage}
            total={total}
            pageSizeOptions={PAGINATION_PAGE_OPTIONS}
            locale={{ items_per_page: "" }}
            showQuickJumper={false}
          />

          <div
            className="absolute h-[48px] flex items-center space-x-[40px] 
          top-0 right-[122px] text-[18px] font-medium text-[#7D7D7D] mr-3"
          >
            <div>Total: {total}</div>
            <div>Row </div>
          </div>
        </div>
      </div>
    </section>
  );
}
